"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Indicator = exports.Header = exports.Wrapper = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../../styles/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Container = _styledComponents["default"].div.withConfig({
  displayName: "style__Container",
  componentId: "sc-10zkfhp-0"
})(["background:", ";width:80%;padding:5px;"], _colors["default"].blueGray.darken2);

exports.Container = Container;

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-10zkfhp-1"
})(["display:flex;flex-direction:column;border-radius:5px;"]);

exports.Wrapper = Wrapper;

var Header = _styledComponents["default"].div.withConfig({
  displayName: "style__Header",
  componentId: "sc-10zkfhp-2"
})(["display:flex;width:100%;"]);

exports.Header = Header;

var Indicator = _styledComponents["default"].div.withConfig({
  displayName: "style__Indicator",
  componentId: "sc-10zkfhp-3"
})(["diplay:flex;height:5px;width:100%;"]);

exports.Indicator = Indicator;